import { Maybe as HygraphMaybe, Spacing as HygraphSpacing } from '@/lib/types';

import { Spacing } from '@/enums/spacing';

export default function spacingTransformer(
  props: HygraphMaybe<HygraphSpacing> | undefined
) {
  switch (props) {
    case HygraphSpacing.Large:
      return Spacing.LARGE;
    case HygraphSpacing.Medium:
      return Spacing.MEDIUM;
    case HygraphSpacing.Small:
      return Spacing.SMALL;
    case HygraphSpacing.None:
      return Spacing.NONE;
    default:
      return undefined;
  }
}
